import { AxiosResponse } from "axios";
import api from "./client";

const isMobileIdentifier = (identifier: string): boolean => /^\d{7,15}$/.test(identifier.trim());

export const sendOtp = (identifier: string): Promise<AxiosResponse> =>
  isMobileIdentifier(identifier)
    ? api.post("/auth/send-otp", { type: "mobile", mobile_number: identifier.trim() })
    : api.post("/auth/send-otp", { type: "email", email: identifier.trim() });

export const verifyOtp = (identifier: string, otp_code: string): Promise<AxiosResponse> =>
  isMobileIdentifier(identifier)
    ? api.post("/auth/verify-otp", { type: "mobile", mobile_number: identifier.trim(), otp_code })
    : api.post("/auth/verify-otp", { type: "email", email: identifier.trim(), otp_code });
